// @flow
import React, { Component } from 'react'
import Loading from '../Icons/loading.gif'
import Paginate from '../Buttons/Paginate'
import './SmsHistoryTable.css'
import InfoIcon from '../../Shared/Icons/icon-info-grey.svg'
import styled from 'styled-components'
import { shortenString } from '../stringUtils'
import { numberedDateLined } from '../timeutils'
import _ from 'lodash'

type Props = {
  changeOffset: Function,
  data: Array,
  fields: Array,
  page: number,
  totalPages: number,
  title: String,
  showTooltip?: Boolean,
  tooltipText?: string
}

const HeaderTitle = styled.span`
  float: left;
  font-size: 20px;
  padding: 17px 15px 25px 23px;
`

/** @const {number} titleMaxLength */
const titleMaxLength = 80

/**
 * Diplay for user table
 * @class
 * @extends Component
 */
class SmsHistoryTable extends Component<Props> {
  /** render function */
  render () {
    const fields = this.props.fields
    const headers = fields.map((field, index) => {
      return (<th key={index}><span>{field.title}</span></th>)
    })
    const data = this.props.data.map((data, i) => {
      if (data.title === 'Loading') {
        return (<tr key={Math.random()}><td><img src={Loading} alt='Loading' /></td></tr>)
      } else if (data.title === '') {
        return false
      } else {
        return (
          <tr key={i}>{fields.map((field) => {
            if (field.ref === 'title') {
              return (<td key={field.ref}>{data[field.ref].length > titleMaxLength ? shortenString(data[field.ref], titleMaxLength) : data[field.ref]}</td>)
            }
            if (field.ref === 'status') {
              return (<td key={field.ref}>{_.upperFirst(data[field.ref])}</td>)
            }
            if (field.ref === 'timestamp') {
              return (<td key={field.ref}>{numberedDateLined(data[field.ref])}</td>)
            }
            return (
              <td key={field.ref}>{data[field.ref] || '0'} </td>
            )
          })}</tr>
        )
      }
    })
    return (
      <div>
        <div className='table-wrapper'>
          <div className='SmsHistoryTable'>
            <div className='flex align-center'>
              <HeaderTitle>{this.props.title}</HeaderTitle>
              { this.props.showTooltip &&
                <div className='tooltip'>
                  <span><img className='icon-md' src={InfoIcon} alt={InfoIcon} /></span>
                  <span className='tooltipText'>{this.props.tooltipText}</span>
                </div>
              }
            </div>
            <table>
              <thead><tr>{headers}</tr></thead>
              <tbody>
              {data}
              </tbody>
            </table>
          </div>
        </div>
        <Paginate changePage={(i) => this.props.changeOffset(i)} page={this.props.page} length={this.props.totalPages} />
      </div>
    )
  }
}
export default SmsHistoryTable
